const useSleep = () => {
    const sleep = (delay) => new Promise(resolve => setTimeout(resolve, delay));

    return { sleep }
}

export default useSleep